"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.radius = exports.layout = exports.space = void 0;
var space = {
  none: '0px',
  xxxs: '2px',
  xxs: '4px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '40px',
  xxxl: '48px'
};
exports.space = space;
var layout = {
  xxs: '16px',
  xs: '24px',
  sm: '32px',
  md: '48px',
  lg: '64px',
  xl: '96px',
  xxl: '128px'
};
exports.layout = layout;
var radius = {
  xs: '1px',
  sm: '2px',
  md: '4px',
  lg: '8px'
};
exports.radius = radius;
var _default = {
  space: space,
  layout: layout,
  radius: radius
};
exports.default = _default;